import { type ComponentType } from "react";
import { cn } from "~/lib/utils";

type NavButtonProps = {
    icon: ComponentType<{ size?: number; className?: string }>;
    onClick: () => void;
    disabled: boolean;
    "aria-label": string;
};

const NavButton = ({ icon: Icon, onClick, disabled, "aria-label": ariaLabel }: NavButtonProps) => {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            aria-label={ariaLabel}
            className={cn(
                "group/nav w-10 h-10 rounded-full border-2 border-primary500 flex items-center justify-center",
                "transition-all duration-200",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary300 focus-visible:ring-offset-2",
                disabled ? "opacity-40" : "hover:bg-primary400 hover:border-primary400 cursor-pointer"
            )}
        >
            <Icon size={22} className={cn(
                "text-primary500 transition-colors duration-200",
                !disabled && "group-hover/nav:text-pureWhite"
            )} />
        </button>
    );
};

export default NavButton;
